<template>
    <div id="div">
        <div id="contact">
            <img src="../components/images/logo_new2.png">
            <p>公司地址：内蒙古自治区兴安盟科尔沁右翼前旗科尔沁镇府前街南金界路西科右前旗双创产业园三楼</p>
            <p>Copyright&copy;兴安盟以恒科技有限公司</p>
            <!-- <p>备案/许可证号：辽ICP备2021006853号</p> -->
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{

        }
    }
}
</script>

<style scoped>
img{
  width: 100px;
  height: 80px;
}
*{
  margin: 0;
  padding: 0;
}
#div{
    width: 100%;
    height: 300px;
    background: #05355c;
}
#contact{
    margin: 0 auto;
    width: 1100px;
    height: 150px;
    text-align: center;
    color: white;
    font-size: 18px;
    
    padding-top: 34px;
}
#contact p{
    margin-top: 8px;
}
</style>